import axios from 'axios';
import { getLocale } from '../util';
import queryString from 'query-string';
import { getNikeoneService, isNikeoneEnabled } from '../../components/nikeone';

export const nikeoneClient = axios.create({
    headers: { 'Content-Language': getLocale() },
    baseURL: getNikeoneService(),
    paramsSerializer: params => queryString.stringify(params)
});

nikeoneClient.interceptors.response.use(response => response.data);

if (!isNikeoneEnabled) {
    nikeoneClient.interceptors.request.use(config => {
        const msg = `Nikeone service endpoint is not configured, aborting request to ${config.url}`;
        console.warn(msg);
        return Promise.reject(msg);
    });
}
